import { ChevronDown } from 'lucide-react';

export default function VotingHeader({ survey, settings, showScrollCue = false, label = 'Voting', showDescription = true, bordered = true }) {
  return (
    <div className={`voting-brand ${bordered ? 'border-bottom' : ''} pb-3 mb-2 mt-4 mx-auto`}>
      <div className="d-flex flex-column flex-sm-row align-items-center gap-3">

        {/* Logo */}
        <a href="/" className="flex-shrink-0 text-center text-decoration-none">
          {settings?.logo ? (
            <img
              src={settings.logo}
              alt={survey?.surveyname || survey?.name || 'Logo'}
              className="voting-brand__logo"
            />
          ) : (
            <div className="rounded-circle d-flex align-items-center justify-content-center bg-primary voting-brand__trophy">
              🏆
            </div>
          )}
        </a>

        {/* Title + stage + description */}
        <div className="flex-grow-1 text-center text-sm-start">
          <h1 className="sidebar-title fs-5 mb-1 text-center">
            {survey?.surveyname || survey?.name || 'Awards'}
            {survey?.period_show && survey?.period && (
              <span> · {survey.period}</span>
            )}
          </h1>

          <div className="d-flex align-items-center gap-2 mb-1">
            <hr className="voting-brand__line flex-grow-1 m-0" />
            <span className="sidebar-stage">{label}</span>
            <hr className="voting-brand__line flex-grow-1 m-0" />
          </div>

          {showDescription && survey?.display_text && (
            <p
              className="voting-brand__desc voting-sidebar-desc mb-0 text-center"
              dangerouslySetInnerHTML={{ __html: survey.display_text }}
            />
          )}
        </div>

      </div>

      {showScrollCue && (
        <div className="text-center mt-1">
          <div className="scroll-arrow d-inline-block" aria-hidden="true">
            <ChevronDown size={18} />
          </div>
        </div>
      )}
    </div>
  );
}
